import boms from "./boms";
import materials from "./materials";
import reports from "./reports";
import schedules from "./schedules";

export default {
    boms,
    materials,
    reports,
    schedules,
};
